Ext.ns('mx.data');

mx.data.AuditData = mx.data.Record.create(
    [
        {name: 'id', type: 'string'},
        {name: 'name', type: 'string'},
        {name: 'user_name', type: 'string'},
        {name: 'entity_name', type: 'string'},
        {name: 'modification_date', type: 'date', dateFormat: 'd/m/Y H:i:s O'},
        {name: 'action_type', type: 'int'},
        {name: 'description', type: 'string'},
    ],
    MXAT.API('audit/')
);

new mx.data.Store({
    storeId: 'audit',
    record: mx.data.AuditData,
    appendable: true,
    url: MXAT.API('audit/'),
});
